import { FunctionComponent, ReactElement } from 'react';

import { ReactComponent as CreateIcon } from '../../../assets/icons/searchbar-icons/icon-create.svg';
import {
  buttonHeight,
  buttonWidth,
} from '../../../components/search-bar/variables/sizes';
import Box from '../../../components/ui/Box';
import Button from '../../../components/ui/Button';
import useChangePrompt from '../../../hooks/use-change-prompt/use-change-prompt.hook';
import { WithFormStateProps } from '../with-releases-layout/models/with-form-state-props.model';
import { useToggleFormVisibility } from './hooks/use-toggle-form-visibility/use-toggle-form-visibility.hook';
import { WithCreateReleaseButtonProps } from './types/with-create-release-button-props.type';

export function withCreateReleaseButton<
  TWrappedComponentProps extends WithFormStateProps
>(
  WrappedComponent: FunctionComponent<TWrappedComponentProps>
): FunctionComponent<WithCreateReleaseButtonProps<TWrappedComponentProps>> {
  return function (props): ReactElement {
    const toggleFormVisibilityHandler = useToggleFormVisibility(
      props.onToggleForm,
      props.changeFormState
    );

    const hookButtonAction = useChangePrompt(
      true,
      toggleFormVisibilityHandler,
      <span>Warning</span>,
      <span>Filled information will be lost. Leave anyway?</span>
    );

    return (
      <>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <Button
            type="button"
            onClick={hookButtonAction}
            sx={{
              backgroundColor: theme => theme.palette.black.main,
              // eslint-disable-next-line @typescript-eslint/naming-convention
              '&:hover': {
                backgroundColor: theme => theme.palette.black.main,
              },
              height: buttonHeight,
              width: buttonWidth,
              ml: 1,
              minWidth: 'unset',
            }}
          >
            <CreateIcon />
          </Button>
        </Box>

        {props.isFormOpen && <WrappedComponent {...props} />}
      </>
    );
  };
}
